import { render } from "./HeaderViewRenewal.vue?vue&type=template&id=10be85d3"
import script from "./HeaderViewRenewal.vue?vue&type=script&lang=js"
export * from "./HeaderViewRenewal.vue?vue&type=script&lang=js"

import "./HeaderViewRenewal.vue?vue&type=style&index=0&id=10be85d3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__